import { useContext } from 'react';
import { DialogContext } from './dialog-context';

export function useDialogContext() {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialogContext must be used inside DialogContext');
  }
  return context;
}
